import mongodb from './mongodb.svg'
import postgres from './postgresql.svg'

const DATABASE = { mongodb, postgres }
export const DATABASE_ARRAY = [mongodb, postgres];

export default DATABASE;